// extracted by LIB_CSS_EXTRACT_LOADER
import "./toolbar_module.css"
export default {"root":"root-FszbvX","group":"group-dsvVsG","item":"item-LO_xsD","button":"button-D0LUpU","link":"link-Ih65ZC","separator":"separator-WqDqFh"};